import React, { useState } from 'react'
import RecipesService from "../../../services/RecipesService";
import { XIcon } from '@heroicons/react/outline'
import Select from 'react-select'
import { UNIT_OPTIONS, gramsFor, gramsForItem } from '../../../services/Units';
import GroceriesService from '../../../services/GroceriesService';

const RecipesForm = ({ userData, recipeData, setRecipeData, groceriesData, modalTitle, setIsOpen, addRecipe }) => {

    const {
        name: nameData,
        description: descriptionData,
        recipeItems: ingredientsData,
        id: idData,
    } = userData;

    let totalCals = ingredientsData ? ingredientsData.reduce(
        (sum, item) => sum + Number(item.calories), 0) : 0;
    let totalCs = ingredientsData ? ingredientsData.reduce(
        (sum, item) => sum + Number(item.carbs), 0) : 0;
    let totalPs = ingredientsData ? ingredientsData.reduce(
        (sum, item) => sum + Number(item.proteins), 0) : 0;
    let totalFs = ingredientsData ? ingredientsData.reduce(
        (sum, item) => sum + Number(item.fats), 0) : 0;

    const [totalCalories, setTotalCalories] = useState(totalCals)
    const [totalCarbs, setTotalCarbs] = useState(totalCs)
    const [totalProteins, setTotalProteins] = useState(totalPs)
    const [totalFats, setTotalFats] = useState(totalFs)
    const [name, setName] = useState(nameData || '');
    const [description, setDescription] = useState(descriptionData || '');
    const [recipeItems, setRecipeItems] = useState(ingredientsData || []);
    const [id, setId] = useState(idData || null);


    const [hasError, setHasError] = useState(false);


    const formValues = { id, name, description, recipeItems };


    const isNullOrWhitespace = value => {
        if (!value || value.trim() === '') {
            return true;
        }
        return false;
    }


    const handleFormSubmit = e => {
        if (recipeItems) recipeItems.forEach(entry => persistPieceWeight(entry));
        e.preventDefault();
        if (isNullOrWhitespace(name) || isNullOrWhitespace(description) || recipeItems.length === 0) {
            setHasError(true);
        } else {
            setIsOpen(false);
            addRecipe(userData, formValues)
        }
    }

    const mapMacros = (item) => {
        item = {
            ...item,
            calories: 0,
            carbohydrates: 0,
            proteins: 0,
            fats: 0,
        }

        item.recipeItems.forEach(x => {
            item.calories += Number(x.ingredient.calories) * (gramsForItem(x) / 100)
            item.carbohydrates += Number(x.ingredient.carbohydrates) * (gramsForItem(x) / 100)
            item.proteins += Number(x.ingredient.proteins) * (gramsForItem(x) / 100)
            item.fats += Number(x.ingredient.fats) * (gramsForItem(x) / 100)
        })

        item = {
            ...item,
            calories: item.calories.toFixed(2),
            carbohydrates: item.carbohydrates.toFixed(2),
            fats: item.fats.toFixed(2),
            proteins: item.proteins.toFixed(2),
        }

        return item;
    }

    const handleEditMeasure = (value, ingredient) => {
        let modifiedIngredients = recipeItems;
        modifiedIngredients = modifiedIngredients.map(item => {
            if (item.ingredient.name === ingredient.name) {
                item.servingSize = Number(value);
            }

            return item;
        });
        setRecipeItems(modifiedIngredients);
        updateTotalCals(modifiedIngredients);
    }

    const handleEditUnit = (value, ingredient) => {
        let modifiedIngredients = recipeItems.map(item => {
            if (item.ingredient.name === ingredient.name) { item.unit = value; if (value === 'kom' && item.pieceWeight == null && item.ingredient.pieceWeight) item.pieceWeight = item.ingredient.pieceWeight; }
            return item;
        });
        setRecipeItems(modifiedIngredients);
        updateTotalCals(modifiedIngredients);
    }

    const persistPieceWeight = (entry) => {
        const ing = entry.ingredient;
        if (ing && ing.id && Number(entry.pieceWeight) > 0) {
            ing.pieceWeight = Number(entry.pieceWeight);
            const updated = {
                id: ing.id, name: ing.name, calories: ing.calories,
                carbohydrates: ing.carbohydrates, proteins: ing.proteins,
                fats: ing.fats, category: ing.category, defaultSize: ing.defaultSize || 100,
                pieceWeight: Number(entry.pieceWeight)
            };
            GroceriesService.updateGrocery(updated).catch(() => { });
        }
    }

    const handleEditPieceWeight = (value, ingredient) => {
        let modifiedIngredients = recipeItems.map(item => {
            if (item.ingredient.name === ingredient.name) { item.pieceWeight = value === '' ? null : Number(value); }
            return item;
        });
        setRecipeItems(modifiedIngredients);
        updateTotalCals(modifiedIngredients);
    }

    const handleChangeSelection = (item) => {
        let fullIngredient = (item.value && typeof item.value === 'object') ? item.value : item;
        let items = [...recipeItems, { ingredient: fullIngredient, servingSize: 100, unit: 'g', pieceWeight: (fullIngredient && fullIngredient.pieceWeight) || null }]
        setRecipeItems(items)
        updateTotalCals(items);
    }

    const handleDeleteIngredient = (id) => {
        let items = recipeItems;
        items = items.filter(item => item.ingredient.id !== id);
        setRecipeItems(items);
        updateTotalCals(items);
    }

    const updateTotalCals = (items) => {
        let tempCals = 0;
        let tempCarbs = 0;
        let tempProteins = 0;
        let tempFats = 0;
        items.map(item => {
            tempCals += Number(item.ingredient.calories) * (gramsForItem(item) / 100);
            tempCarbs += Number(item.ingredient.carbohydrates) * (gramsForItem(item) / 100);
            tempProteins += Number(item.ingredient.proteins) * (gramsForItem(item) / 100);
            tempFats += Number(item.ingredient.fats) * (gramsForItem(item) / 100);
        })
        setTotalCalories(Number(tempCals).toFixed(2))
        setTotalCarbs(Number(tempCarbs).toFixed(2))
        setTotalProteins(Number(tempProteins).toFixed(2))
        setTotalFats(Number(tempFats).toFixed(2))
    }

    return (
        <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium '>{modalTitle}</h3>
            <form className="w-full mt-6  px-4">
                <div className="input-group">
                    <label className="font-medium text-xs text-gray-500">Naziv</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(name) && <span className="input-error">Unesite ime recepta.</span>}
                    {hasError}
                </div>
                <div className="relative mt-3">
                    <label className="font-medium text-xs text-gray-500">Namirnice</label>
                    <Select
                        placeholder={'Ukucajte da biste pretražili...'}
                        onChange={(item) => handleChangeSelection(item)}
                        options={groceriesData}
                        classNamePrefix='select'
                    />
                    {recipeItems.map((entry, key) => { const { ingredient, servingSize, unit } = entry; return (
                        <div className="relative flex items-center mt-3 p-2 pr-4 bg-bluePrimary bg-opacity-10 rounded" key={key}>
                            <span key={key}>{ingredient.name}</span>
                            <div className='relative  ml-auto'>
                                <input type="number" placeholder="Measure" value={servingSize} onChange={(e) => handleEditMeasure(e.target.value, ingredient)} className="input-field w-20 pl-2 pr-1" />
                                <select value={unit || 'g'} onChange={(e) => handleEditUnit(e.target.value, ingredient)} className='ml-1 text-xs bg-white border border-gray-300 rounded py-1.5 px-1 cursor-pointer'>
                                    {UNIT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                </select>
                                {entry.unit === 'kom' &&
                                    <input type="number" placeholder="g/kom" value={entry.pieceWeight != null ? entry.pieceWeight : ''} onChange={(e) => handleEditPieceWeight(e.target.value, ingredient)} onBlur={() => persistPieceWeight(entry)} className="input-field w-16 ml-1 pl-1 pr-1 text-xs placeholder:text-[10px]" />}
                            </div>
                            <span onClick={() => handleDeleteIngredient(ingredient.id)} className="absolute top-0 right-0 flex items-center justify-center transform -translate-y-1/2 translate-x-1/2 w-4 h-4 border border-red-700 bg-white rounded-full  cursor-pointer">
                                <XIcon className='text-red-800 w-3 h-3' />
                            </span>
                        </div>
                    )})}

                    <p className="font-medium mt-5">Ukupno kalorija - {Number(totalCalories).toFixed(2)}</p>
                    <p className="font-medium mt-1">Ukupno proteina - {Number(totalProteins).toFixed(2)}</p>
                    <p className="font-medium mt-1">Ukupno ugljenih hidrata - {Number(totalCarbs).toFixed(2)}</p>
                    <p className="font-medium mt-1">Ukupno masti - {Number(totalFats).toFixed(2)}</p>
                    {hasError && (recipeItems.length === 0) &&
                        <span className="input-error">Unesite namirnicu.</span>}
                </div>

                <div className="input-group mt-5">
                    <label className="font-medium text-xs text-gray-500">Opis</label>
                    <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="input-field h-52" >
                    </textarea>
                    {hasError && isNullOrWhitespace(description) && <span className="input-error">Unesite opis recepta.</span>}
                </div>
                <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleFormSubmit(e)}>
                    Sačuvaj
                </button>
            </form>
        </>
    )
}
export default RecipesForm;
